

export const frontMatter = {};
export const contentTitle = 'ProgressBar';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-components-progress-bar-mdx-db0.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Features",
  "id": "features",
  "level": 3
}, {
  "value": "Known issues",
  "id": "known-issues",
  "level": 3
}, {
  "value": "Live example",
  "id": "live-example",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h3: "h3",
    header: "header",
    li: "li",
    p: "p",
    pre: "pre",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "progressbar",
        children: "ProgressBar"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://jetbrains.github.io/ui/controls/progress_bar/",
        children: "ProgressBar"
      }), " component, for showing a simple progress bar, or\na ", _jsx(_components.a, {
        href: "https://github.com/JetBrains/intellij-community/blob/82f201386c3f7a339ff25fc8f3389024c8078a87/platform/platform-api/src/com/intellij/openapi/ui/panel/ProgressPanel.java#L28",
        children: "ProgressPanel"
      }), ",\nconsisted of a progress bar, a label, details, and control buttons."]
    }), "\n", _jsx(_components.h3, {
      id: "features",
      children: "Features"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Showing ", _jsx(_components.a, {
          href: "https://jetbrains.github.io/ui/controls/progress_bar/#process-name",
          children: "process name"
        }), " and\n", _jsx(_components.a, {
          href: "https://jetbrains.github.io/ui/controls/progress_bar/#process-details",
          children: "details"
        }), "."]
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://jetbrains.github.io/ui/controls/progress_bar/#04",
          children: "Indeterminate"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["Value label for ", _jsx(_components.a, {
          href: "https://jetbrains.github.io/ui/controls/progress_bar/#13",
          children: "showing percentage when space is limited"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://jetbrains.github.io/ui/controls/progress_bar/#process-control",
          children: "Pause, resume and cancel buttons"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "known-issues",
      children: "Known issues"
    }), "\n", _jsx(_components.p, {
      children: "There are a couple of UI issues because of the current layout (which can be improved probably):"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "max-width of the label and details, it's not necessarily aligned with the the progressbar track, because they don't\nshare the same container"
      }), "\n", _jsx(_components.li, {
        children: "when label is on the side, details is aligned with the label, instead of the progressbar track."
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "live-example",
      children: "Live example"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        metastring: "live themed",
        live: true,
        children: "<>\n  <ProgressBar value={20} /> <br />\n  <ProgressBar isIndeterminate name=\"Indeterminate\" /> <br />\n  <ProgressBar\n    value={40}\n    name=\"With name, details and controls\"\n    details=\"10 files of 256 files - About 10 minutes left\"\n    button={\n      <>\n        <ProgressBarPauseButton\n          paused={false} /* try changing this to true */\n        />\n        {/* <ProgressBarStopButton /> */}\n      </>\n    }\n  />\n  <br />\n  <ProgressBar value={70} name=\"Name on side:\" namePosition=\"side\" /> <br />\n  <br />\n  <ProgressBar\n    value={70}\n    name=\"With value label:\"\n    namePosition=\"side\"\n    showValueLabel\n  />\n  <br />\n  <ProgressBar value={25} name=\"In dialog\" button={<Button>Cancel</Button>} />\n  <br />\n</>\n"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

